const state = {
  mobileNo: localStorage.getItem("mobileNo") || "",
  isLogin: localStorage.getItem("isLogin") === "true" || false,
};

const mutations = {
  SET_USER(state, payload) {
    state.mobileNo = payload.mobileNo;
    state.isLogin = payload.isLogin;
    // 写入浏览器（localStorage）
    localStorage.setItem("phone", payload.phone);
    localStorage.setItem("isLogin", payload.isLogin);
  },

  LOGOUT(state) {
    state.mobileNo = "";
    state.isLogin = false;
    localStorage.removeItem("mobileNo");
    localStorage.removeItem("isLogin");
  }
};

const actions = {
  login({ commit }, payload) {
    commit("SET_USER", payload);
  },

  logout({ commit }) {
    commit("LOGOUT");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
